import styled from 'styled-components'

import { Spinner } from './Spinner'
import { PrimaryButton } from './styledComponents'

const CustomButton = styled(PrimaryButton)`
  float: right;
  padding-top: 4px;
`

const SpinnerButton = () => (
  <CustomButton id="spinner-button" disabled={true}>
    <Spinner light={true} />
  </CustomButton>
)

export { SpinnerButton }
